<template>
  <div class="enterprise-page">
    <div class="hero-section">
      <div class="video">
        <NuxtImg
          :src="`${baseUrl}/static/images/cube-first-frame.png`"
          alt="spatial-img"
          :preload="true"
          v-show="!isPlaying"
          fetchPriority="high"
        />
        <div class="overlay">
          <div class="gradient"></div>
        </div>
      </div>
      <div class="title">
        <NuxtImg
          :src="`${baseUrl}/static/images/spatial-img.svg`"
          alt="spatial-img"
          :preload="true"
          fetchPriority="high"
          v-if="isPortrait"
        />
        <NuxtImg
          :src="`${baseUrl}/static/images/spatial-img1.svg`"
          alt="spatial-img"
          :preload="true"
          fetchPriority="high"
          v-else
        />
        <div class="icons-wrapper" v-if="isPortrait">
          <div class="store">
            <a
              v-if="isPortrait ? $isIPhone : true"
              href="https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819"
              target="_blank"
              rel="noopener noreferrer"
              ><NuxtImg
                format="avif"
                :src="`${baseUrl}/static/images/app-store.svg`"
                alt="AppStore"
                preload
                fetchPriority="high"
            /></a>
          </div>
          <div class="store">
            <a
              v-if="isPortrait ? !$isIPhone : true"
              href="https://play.google.com/store/apps/details?id=com.travvir.studio"
              target="_blank"
              rel="noopener noreferrer"
              ><NuxtImg
                format="avif"
                :src="`${baseUrl}/static/images/play-store.png`"
                alt="Playtore"
                preload
                fetchPriority="high"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePropertyStore } from "~/store/property";

const propertyStore = usePropertyStore();
let propertyId = "W4KyJj";
await propertyStore.getProperty(propertyId);
const config = useRuntimeConfig();
const { $isIPhone } = useNuxtApp();
const isPortrait = inject("isPortrait");
const baseUrl = config.public.NUXT_CDN_URL;
const isPlaying = ref(false);
</script>

<style lang="scss" scoped>
.enterprise-page {
  background: #000000;
  color: white;
}

.container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 4rem;
  width: 100%;

  @include respond-below(lg) {
    padding: 0 3rem;
  }

  @include respond-below(sm) {
    padding: 0 1rem;
  }
}

.hero-section {
  padding: 4rem 0;
  min-height: calc(var(--vh, 1vh) * 100);
  display: flex;
  padding: 6rem 0;
  background: rgba(10, 10, 10, 0.2);
  text-align: center;
  justify-content: center;
  @include respond-below(sm) {
    padding: 4rem 0;
    height: fit-content;
  }
  .video {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    height: 100%;
    // height: calc(var(--vh, 1vh) * 100);
    object-fit: contain;
    // filter: brightness(0.85);
    @include respond-below(sm) {
      width: 100%;
      // height: 100%;
      height: calc(var(--vh, 1vh) * 50);
      // top: 38%;
      top: calc(var(--vh, 1vh) * 38);
      transform: translate(-50%, -50%);
      filter: brightness(1);
    }
    img {
      width: 100%;
      height: 70%;
      // height: calc(var(--vh, 1vh) * 70);
      object-fit: contain;
      position: absolute;
      left: 0%;
      z-index: 1;
      @include respond-below(sm) {
        // height: 100%;
        height: calc(var(--vh, 1vh) * 100);
        object-fit: contain;
      }
    }
    &:deep(#mux-video) {
      width: 100%;
      height: calc(var(--vh, 1vh) * 70);
      object-fit: contain;
      @include respond-below(sm) {
        // height: 100%;
        height: calc(var(--vh, 1vh) * 50);
        object-fit: contain;
      }
    }
    &:deep(img) {
      object-fit: contain;
      @include respond-below(sm) {
        // height: 100%;
        height: calc(var(--vh, 1vh) * 50);
        object-fit: cover;
      }
    }
    &:deep(video) {
      width: 100%;
      height: 100%;
      object-fit: contain;
      @include respond-below(sm) {
        height: 100%;
        object-fit: cover;
      }
    }
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 70%;
      z-index: 1;
      display: flex;
      align-items: end;
      justify-content: end;
      @include respond-below(sm) {
        background: radial-gradient(
          circle at center,
          transparent 58%,
          rgba(0, 0, 0, 0.1) 62%,
          rgba(0, 0, 0, 0.3) 68%,
          rgba(0, 0, 0, 0.6) 75%,
          rgba(0, 0, 0, 0.8) 82%,
          #000 90%
        );
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 102%;
        padding-bottom: 0rem;
      }
      .gradient {
        background: linear-gradient(
          0deg,
          #000 0,
          rgba(0, 0, 0, 0.738) 19%,
          rgba(0, 0, 0, 0.541) 34%,
          rgba(0, 0, 0, 0.382) 47%,
          rgba(0, 0, 0, 0.278) 56.5%,
          rgba(0, 0, 0, 0.194) 65%,
          rgba(0, 0, 0, 0.126) 73%,
          rgba(0, 0, 0, 0.075) 80.2%,
          rgba(0, 0, 0, 0.042) 86.1%,
          rgba(0, 0, 0, 0.021) 91%,
          rgba(0, 0, 0, 0.008) 95.2%,
          rgba(0, 0, 0, 0.002) 98.2%,
          transparent
        );
        // height: 25vh;
        height: calc(var(--vh, 1vh) * 25);
        @include mq(portrait) {
          margin-bottom: 9rem;
        }
        width: 100%;
        @include respond-below(sm) {
          margin-bottom: 0rem;
          height: 100px;
        }
      }
    }
  }

  .title {
    position: absolute;
    z-index: 3;
    bottom: 13%;
    // margin-top: 2rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    letter-spacing: -8.68px;
    line-height: 142.6px;
    // gap: rem;
    img {
      width: 60%;
      object-fit: contain;
    }
    .icons-wrapper {
      pointer-events: auto;
      margin-top: 2rem;
      gap: 0rem;
      justify-content: center;
      align-items: center;
      display: flex;
      width: 70%;
      position: relative;
      z-index: 100;
      .store {
        width: unset;
        margin: unset;
        justify-content: center;
        margin-left: 0rem;
        &:nth-child(2) {
          margin-left: 0rem;
          justify-content: start;
          a {
            width: 140px;
          }
        }
        a {
          width: 140px;
          height: unset;
          @extend %flex-center;
          &:nth-child(2) {
            width: 140px;
          }
          // justify-content: flex-end;
          img {
            width: 100%;
          }
        }
      }
    }
    @include respond-below(sm) {
      position: absolute;
      top: 0;
      width: 100%;
      height: calc(var(--vh, 1vh) * 100);
      display: flex;
      align-items: center;
      justify-content: end;
      flex-direction: column;
      padding-bottom: calc(var(--vh, 1vh) * 11);

      img {
        width: 80%;
      }
    }
  }
}
</style>
